/* eslint-disable react/jsx-props-no-spreading */

import * as React from "react";
import { IconCheck, IconEye, IconEyeOff } from "@tabler/icons-react";

interface Props {
  id: string;
  label: string | React.ReactNode;
  required?: boolean;
}

const Checkbox: React.FC<Props & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>> = ({
  id, label, type, required, className, checked, ...props
}) => (
  <div className="flex gap-2">
    <div className="relative">
      <input
        id={id}
        type="checkbox"
        className={`appearance-none h-5 w-5 border-[1.5px] border-slate-300 checked:border-blue-600 rounded
          checked:bg-blue-600 text-transparent checked:text-white hover:cursor-pointer
          disabled:accent-gray-50 disabled:text-gray-500 disabled:border-slate-200 ${className}`}
        checked={checked}
        {...props}
      />
      {checked && (
        <IconCheck className="absolute z-10 inset-0 h-5 w-5 text-white pointer-events-none" />
      )}
    </div>

    <label htmlFor={id} className="text-sm">
      {label}
      {required && <span className="text-red-600">*</span>}
    </label>

  </div>
);

export default Checkbox;
